import { ReactNode } from 'react'
import cx from 'classnames'
import styles from './RowList.module.css'

/** 시안 `.rows`/`.row` 이식. 워크플로 대기 목록 등 이름+설명+우측 액션 패턴에 쓴다. */
export type RowListRow = {
  key: string
  name: ReactNode
  mono?: boolean
  desc?: ReactNode
  right?: ReactNode
}

export type RowListProps = {
  rows: RowListRow[]
}

export const RowList = ({ rows }: RowListProps): JSX.Element => (
  <div className={styles.rows}>
    {rows.map((row) => (
      <div className={styles.row} key={row.key}>
        <div className={styles.lead}>
          <div className={cx(styles.nm, row.mono && styles.mono)}>{row.name}</div>
          {row.desc ? <div className={styles.ds}>{row.desc}</div> : null}
        </div>
        {row.right ? <div className={styles.rt}>{row.right}</div> : null}
      </div>
    ))}
  </div>
)
